// This component is used to register a temporary field to activate auto scroll for fields that are not accessible in the DOM when submitting the form (like fields in modals)

import { FormHelperText, FormHelperTextProps } from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';

interface FormHiddenFieldProps extends FormHelperTextProps {
    /**
     * Specifies the key in the form's data object
     */
    name: string;
    /**
     * Connects field to the form context
     */
    control: Control<any>;
    /**
     * Custom validation errors
     */
    customError?: string;
    hideError?: boolean;
}

/**
 * For use within RHF FormProvider
 */
const FormHiddenField = ({
    name,
    control,
    customError,
    hideError,
    ...helperTextProps
}: FormHiddenFieldProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { value, onChange, ref },
                fieldState: { error },
            }) => {
                const errorMessage = !hideError
                    ? error?.message || customError
                    : undefined;

                return (
                    <>
                        <input
                            ref={ref}
                            type='text'
                            name={name}
                            value={value ?? ''}
                            onChange={onChange}
                            tabIndex={-1} // skip element focus when user presses Tab
                            style={{
                                position: 'absolute',
                                width: 1,
                                height: 1,
                                padding: 0,
                                margin: 0,
                                border: 0,
                                opacity: 0,
                                pointerEvents: 'none',
                            }}
                        />
                        {errorMessage ? (
                            <FormHelperText error {...helperTextProps}>
                                {errorMessage}
                            </FormHelperText>
                        ) : null}
                    </>
                );
            }}
        />
    );
};

export default FormHiddenField;
